import { Component} from '@angular/core';
import { Constants } from '../../../constants'; 
import { HomeService } from 'src/services/home/home.service';
import { SweetServices } from 'src/services/sweet.services';

@Component({
  selector: 'app-soporte',
  templateUrl: './soporte.component.html',
  styleUrls: ['./soporte.component.css']
})
export class SoporteComponent {
  public appdata:any;
  titulo = Constants.SOPORTE;
  totalDias = 0;
  diasRestantes = 0;
  porcentajeConsumido = 0.0;
  color = 'verde';
  descripcionRenovacion = 'renovación ....';

  contacto = {
    address : '',
    email : '',
    manager : '',
    phone : '',
    helpDeskUrl:''
  }

  poliza = { 
    no:'',
    type :'',
    status:'',
    startDate: new Date("2026-01-01"),
    finalDate : new Date("2026-01-01"),
    activationDate : new Date("2030-01-01")
  }

  constructor(
    private homeService: HomeService,
    private alert: SweetServices
  ){
    this.appdata = this.homeService.getEnvironment();
    this.contacto = this.appdata.licenseData.support;
    this.poliza = this.appdata.licenseData.purchaseAgreement;

    const start = new Date(this.poliza.startDate).getTime();
    const end = new Date(this.poliza.finalDate).getTime();
    const now = new Date().getTime();
    const msPerDay = 1000 * 60 * 60 * 24;

    this.totalDias = Math.ceil((end - start) / msPerDay);
    this.diasRestantes = Math.ceil((end - now) / msPerDay);

    this.porcentajeConsumido = 100 -((this.diasRestantes * 100) / this.totalDias);
    this,this.descripcionRenovacion = `Renovación en ${this.diasRestantes} días`;

    if (this.porcentajeConsumido <= 70) {
      this.color = 'verde'; 
    } else if (this.porcentajeConsumido <= 90) {
      this.color = 'amarillo'; 
    } else {
      this.color = 'rojo'; 
      this.alert.AlertaAdvertencia("La vigencia está por caducar");
    }
  }

  openHelpDesk(url: string) {
    window.open(url, '_blank'); 
  }
}